import React, {useState} from "react";
import {useSelector} from "react-redux";
import SVG from "react-inlinesvg";
import {toAbsoluteUrl} from "../../../../../_metronic/_helpers";
import {formatDate, permissionCssClass} from "../../../../util/Helpers";
import {Permissions, PermissionType} from "../../../../util/Permissions";
import {Card, CardBody, CardHeader, CardHeaderToolbar} from "../../../../../_metronic/_partials/controls";
import TableSkeleton from "../../../../util/TableSkeleton";
import {Link} from "react-router-dom"
import SimpleTable from "my-simple-react-table";
import {useGetBanksQuery} from "../../../../../redux/apiSlice";
import DeleteBankModal from "../modals/DeleteBankModal";

const ViewBanks = ({history}) => {
    const adminUser = useSelector(state => state.auth.user);

    const {isFetching, data: banks} = useGetBanksQuery()

    /* Exchange Rate Modal State Management */
    const [bankModal, setBankModal] = useState({
        showDeleteBankModal: false,
        details: null
    });

    /* Modal show/hide Toggle */
    const toggleModal = modal => _ => {
        setBankModal({...bankModal, [modal]: !bankModal[modal]})
    }

    /* Delete Exchange Rate Modal */
    const deleteBank = (details) => {
        setBankModal({...bankModal, showDeleteBankModal: true, details});
    }

    /* Action Buttons */
    const bankAction = (row) => {
        return (
            <span style={{whiteSpace: "nowrap"}}>
                <button
                    onClick={() => history.push(`/overview/banks/edit/${row.ref}`)}
                    className={`btn btn-icon btn-light btn-hover-primary btn-sm mx-3 ${permissionCssClass(adminUser, Permissions.BANKS, PermissionType.UPDATE)}`}
                >
                    <span className="svg-icon svg-icon-md svg-icon-primary">
                      <SVG
                          title="Edit Bank"
                          src={toAbsoluteUrl("/media/svg/icons/Communication/Write.svg")}
                      />
                    </span>
                </button>
                <button
                    className={`btn btn-icon btn-white btn-hover-danger btn-sm ${permissionCssClass(adminUser, Permissions.BANKS, PermissionType.DELETE)}`}
                    onClick={_ => deleteBank(row)}
                >
                    <span
                        className={`svg-icon svg-icon-md svg-icon-danger`}>
                        <SVG
                            title="Delete Bank"
                            src={toAbsoluteUrl("/media/svg/icons/Code/Error-circle.svg")}
                        />
                    </span>
                </button>
            </span>
        );
    };

    return (
        <>
            <Card>
                <CardHeader title="Banks list">
                    <CardHeaderToolbar>
                        <Link
                            to={"/overview/banks/create"}
                            className={`btn btn-primary ${permissionCssClass(adminUser, Permissions.BANKS, PermissionType.CREATE)}`}
                        >
                            New Bank
                        </Link>
                    </CardHeaderToolbar>
                </CardHeader>
                <CardBody>
                    {isFetching ? (
                        <TableSkeleton/>
                    ) : (
                        <SimpleTable
                            data={banks?.data || []}
                            columns={[
                                {title: "NAME", key: "bankName"},
                                {title: "CURRENCY", key: "currency"},
                                {title: "COUNTRY", key: "country"},
                                {title: "CREATED ON", format: (row) => formatDate(row.createdAt)},
                                {title: "UPDATED ON", format: (row) => formatDate(row.updatedAt)},
                                {title: "", format: bankAction},
                            ]}
                        />
                    )}
                </CardBody>
            </Card>

            <DeleteBankModal
                {...bankModal}
                onHide={toggleModal("showDeleteBankModal")}
                details={bankModal.details}
            />

        </>
    );
};

export default ViewBanks;